/**
 * A request that never got a response, told apart from one the server
 * answered (TOADO-995).
 *
 * `fetch` rejects with a TypeError both when the request never reached the
 * server and when the body of a response the server did send fails to read,
 * so the error's type cannot say which. The code that calls `fetch` can: it
 * marks the rejection of the `fetch` call itself, and nothing that happens
 * after a response arrives. The upload controller then waits on, rather than
 * spending an attempt, only where the server has said nothing.
 */
export function markUnanswered(error: unknown): unknown {
  if (error !== null && typeof error === 'object') {
    try {
      Object.defineProperty(error, 'requestUnanswered', { value: true, configurable: true });
    } catch {
      // A frozen error stays unmarked, and is counted as an answer: the safe side.
    }
  }
  return error;
}

/** Whether `markUnanswered` marked this error. */
export function requestWentUnanswered(error: unknown): boolean {
  return error !== null && typeof error === 'object'
    && (error as { requestUnanswered?: unknown }).requestUnanswered === true;
}
